import { ReactNode } from 'react';
import { Paper } from '@mantine/core';

interface AuthCardProps {
  children: ReactNode;
  w?: number | undefined | string;
}

export const AuthCard = ({ children, w = 490 }: AuthCardProps) => (
  <Paper bg="gray.0" radius="xl" py={48} px={48} w={w}>
    {children}
  </Paper>
);
